import { Vector3 } from 'three';

const RENDERER_CONFIG = {
	SCENE_BACKGROUND: 0xffffff,
	GRID: {
		COLOR: 0xc9c9c9,
		SIZE: 125,
		POS_Y: 0.01,
		LAYER: 6,
	},
	LIGHTS: {
		COLOR: 0xffffff,
		POS_Y: 100,
	},
	CAMERA: {
		ORTHO: {
			FRUSTRUM_SIZE: 25,
			MAX_ZOOM_IN: 5,
			MAX_ZOOM_OUT: 0.2,
			ZOOM_TICK: 0.25,
		},
		PERSPECTIVE: {
			MIN_DISTANCE: 5,
			MAX_DISTANCE: 100,
			DISTANCE_TICK: 2.5,
		},
	},
	TRANSFORM_CONTROLS: {
		ROTATION_SNAP: 5,
		TRANSLATION_SNAP: 0.1,
	},
	COLLISIONS: {
		BOX3_EXPAND_VECTOR: new Vector3(0, 1, 0),
	},
	SCREENSHOT: {
		WIDTH: 1920,
		HEIGHT: 1080,
		FLOOR_SIZE_OFFSET: 5,
		PERSPECITIVE_CAMERAS: [
			{
				POSITION: new Vector3(-15, 20, 15),
				TARGET: new Vector3(0, 0, 0),
			},
			{
				POSITION: new Vector3(15, 20, -15),
				TARGET: new Vector3(0, 0, 0),
			},
		],
	},
	CONTROLS: {
		PAN_SPEED: 0.8,
		MAX_POLAR_ANGLE: 85,
		SCREEN_SPACE_PANNING: false,
		ROTATE_SPEED: 10,
		ROTATE_TIME: 500,
	},
	INITIAL_ZOOM: 1,
	INITIAL_DISTANCE: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
	VERTEX: {
		HEIGHT: 1,
		RADIUS: 0.25,
		CLOSE_THRESHOLD: 1,
	},
	PLAYGROUND_LINE: {
		WIDTH: 5,
		HEIGHT: 0.05,
		LABEL_TO_LINE_OFFSET: 1,
	},
	MEASUREMENT: {
		LAYER: 5,
		WIDTH: 3,
		POS_Y: 10,
		LINE_OFFSET: 0.25,
		LABEL_TO_LINE_OFFSET: 0.5,
	},
	COLLIDABLE_MODULE: {
		LAYER: 3,
	},
	LINE_MIN_LENGTH: 1,
	LINE_MAX_LENGTH: 100,
	PLANE_Y: 0,
	FLOOR_Y: 0.02,
	LINE_Y: 0.02,
	COLLIDABLE_MODULE_POS_Y: 0.025,
	MOUSE: {
		UNSELECT_DISTANCE: 0.01,
		SHIFT_MOVE_SNAP: 0.5,
	},
	COLORS: {
		GREEN: 0x087f5b,
		RED: 0xc92a2a,
		CREAM: 0xde9556,
		LIGHT_CREAM: 0xf8f2e7,
		BLACK: 0x141414,
	},
	CIRCLE_SHAPE: {
		DIAMETER: {
			DEFAULT: 20,
			MIN: 10,
			MAX: 100,
		},
		SEGMENTS: 64,
	},
} as const;

export default RENDERER_CONFIG;
